import { Outlet } from "react-router-dom";
import CategoryList from "./CategoryList";
import CategoryForm from "./CategoryForm";

export const productsCategoriesRoutes = [
  {
    path: "categories",
    element: Outlet,
    children: [
      {
        path: "",
        element: CategoryList,
      },
      {
        path: "add",
        element: CategoryForm,
      },
      {
        path: "edit/:id",
        element: CategoryForm,
      },
    ],
  },
];
